"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var revert_error_1 = require("../../revert_error");
// tslint:disable:max-classes-per-file
var DivisionByZeroError = /** @class */ (function (_super) {
    __extends(DivisionByZeroError, _super);
    function DivisionByZeroError() {
        return _super.call(this, 'DivisionByZeroError', 'DivisionByZeroError()', {}) || this;
    }
    return DivisionByZeroError;
}(revert_error_1.RevertError));
exports.DivisionByZeroError = DivisionByZeroError;
var RoundingError = /** @class */ (function (_super) {
    __extends(RoundingError, _super);
    function RoundingError(numerator, denominator, target) {
        return _super.call(this, 'RoundingError', 'RoundingError(uint256 numerator, uint256 denominator, uint256 target)', {
            numerator: numerator,
            denominator: denominator,
            target: target,
        }) || this;
    }
    return RoundingError;
}(revert_error_1.RevertError));
exports.RoundingError = RoundingError;
var types = [DivisionByZeroError, RoundingError];
try {
    // Register the types we've defined.
    for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
        var type = types_1_1.value;
        revert_error_1.RevertError.registerType(type);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=lib_math_revert_errors.js.map